import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from 'torqcloud-ui'

import { playground } from '@/constants/routing'
import useOrganizationSettingsAccess from '@/hooks/useOrganizationSettingsAccess'

export default function OrganizationSettingsGuard({ children }: { children: ReactNode }) {
  const { hasMetadata } = useAuth()
  const { canAccessOrganizationSettings } = useOrganizationSettingsAccess()

  if (!hasMetadata) {
    return null
  }

  if (!canAccessOrganizationSettings) {
    return <Navigate to={playground()} replace />
  }

  return <>{children}</>
}
